import { z } from 'zod';

import { BasePType } from './base';

export const FaqItem = BasePType.extend({
  type: z.enum(['faqItem']),
  body: z.string(),
  faqFilterTag: z.string().nullable().optional(),
  title: z.string(),
});

export type FaqItem = z.infer<typeof FaqItem>;
